export const normalizeName = (name: string) => name.replace(/ /, '').toLowerCase();
